import {
  getRecurringTransactionReport,
  RecurringTransactionReportResponse,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import downloadFile, { base64DownloadXlsx } from '../../utils/file';
import { handleNotAuthorized, Self } from '../common';

function* RecurringTransactionReportRequest(
  self: Self,
  query: string
): Generator<Promise<FlowReturn<RecurringTransactionReportResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getRecurringTransactionReport(query);
    const { data, status } = (response as RecurringTransactionReportResponse)
      .data;
    if (status.code === 1000) {
      base64DownloadXlsx(data.file_content, data.file_name, downloadFile);

      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default RecurringTransactionReportRequest;
